import styled, { css } from 'styled-components';

export const LayoutContainer = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
`;
export const Overlay = styled.div`
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    background-color: ${(props) => props.theme.black_48_tr_base};
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: -1;

    ${(props) => {
        if (props.$animationInProgress === 1 || props.$openedBottomLayout) {
            return css`
                opacity: 1;
                z-index: auto;
            `;
        }
    }}
`;
export const LayoutBottom = styled.div`
    padding-bottom: 96px;
    border-radius: 12px 12px 0 0;
    overflow-y: ${(props) => (props.$animationInProgress === 0 ? 'auto' : 'hidden')};
    overflow-x: hidden;
    background-color: ${(props) => props.theme.white};
    transition: top 0.3s ease-out;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: ${(props) => `${props.$topPosition}px`};

    &::-webkit-scrollbar {
        display: none;
    }

    &.bottom-move {
        top: 104px;
        overscroll-behavior: contain;
    }
`;

export const LayoutBottomInner = styled.div`
    min-height: calc(100vh - 60px);
`;
export const LayoutBottomHandler = styled.div`
    width: 100%;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:before {
        content: '';
        display: inline-block;
        width: 32px;
        height: 4px;
        border-radius: 4px;
        background-color: ${(props) => props.theme.grey_16_tr};
    }
`;
